import {get, post} from '../request';

export const homeLogin = (params) => post(`/api/v1/admin/home/adminLogin`,params)
